import { createRoot } from 'react-dom/client';
import GlobalStyles from '@styles/GlobalStyles';
import { QueryClientProvider } from '@tanstack/react-query';
import App from './App.jsx';
import '@/styles/index.css';
import { queryClient } from '@/query-client';
import { initMixpanel } from './services/analytics.js';
import './i18n';
import * as Sentry from '@sentry/react';
import { APP_CONFIG } from '@/constants/config';

Sentry.init({
  dsn: APP_CONFIG.SENTRY_DSN,
  environment: APP_CONFIG.SENTRY_ENVIRONMENT,
  // Build metadata (commit hash), the only value still baked in at build time.
  release: import.meta.env.VITE_SENTRY_RELEASE,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  tracesSampleRate: APP_CONFIG.SENTRY_TRACES_SAMPLE_RATE,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  sendDefaultPii: false,
  enabled: import.meta.env.PROD,
});

// Auto-reload when a stale chunk is requested after a new deployment
const isChunkError = msg =>
  msg?.includes('Failed to fetch dynamically imported module') ||
  msg?.includes('Importing a module script failed') ||
  msg?.includes('Unable to preload CSS');

window.addEventListener('vite:preloadError', () => window.location.reload());
window.addEventListener('unhandledrejection', event => {
  if (isChunkError(event.reason?.message)) window.location.reload();
});
initMixpanel();
createRoot(document.getElementById('root')).render(
  <Sentry.ErrorBoundary showDialog>
    <QueryClientProvider client={queryClient}>
      <GlobalStyles />
      <App />
    </QueryClientProvider>
  </Sentry.ErrorBoundary>
);
